import { Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import banner from "@/assets/banner.jpg";
import { API_BASE_URL } from "@/lib/api";

export function CraftBanner() {
  const { data: settings } = useQuery({
    queryKey: ["settings"],
    queryFn: async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/settings`);
        if (res.ok) return await res.json();
      } catch (err) {
        // silent fallback
      }
      return null;
    }
  });

  const craftTitle = settings?.craftTitle || "Pure Craftsmanship";
  const craftDesc = settings?.craftDesc || "Every candle is a reflection of our commitment to quality, warmth and the quiet ritual of light. Poured by hand, one flame at a time.";

  return (
    <section className="relative overflow-hidden">
      <div className="relative min-h-[520px] flex items-center">
        <img src={banner} alt="" loading="lazy" className="absolute inset-0 h-full w-full object-cover" width={1920} height={912} />
        <div className="absolute inset-0 bg-gradient-to-r from-primary via-primary/85 to-primary/20" />
        <div className="relative mx-auto max-w-[1400px] px-6 lg:px-10 py-24 text-cream">
          <p className="eyebrow">Our Craft</p>
          <h2 className="mt-4 font-display text-4xl md:text-6xl leading-[1.05] max-w-xl">
            {craftTitle}
          </h2>
          <p className="mt-6 max-w-md text-cream/70 leading-relaxed">
            {craftDesc}
          </p>
          <Link to="/about" className="mt-8 btn-gold">Discover Our Story</Link>
        </div>
      </div>
    </section>
  );
}
